(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdtn-chassis-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-rdtn-category-sort] select')) event.target.form.requestSubmit();
  });
  document.querySelectorAll('[data-rdtn-category-sort] button').forEach((button) => { button.hidden = true; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdtn-collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => { document.querySelectorAll('.rdtn-collection-header__switch[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; }); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') document.querySelectorAll('.rdtn-collection-header__switch[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdtn-e36-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-rdtn-category-sort] select')) event.target.form.requestSubmit();
  });
  document.querySelectorAll('[data-rdtn-category-sort] button').forEach((button) => { button.hidden = true; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdtn-instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rdtn-instagram')) {
    customElements.define('rdtn-instagram', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        const feed = this.querySelector('.rdtn-instagram__feed');
        const refresh = () => {
          const ready = [...feed.querySelectorAll('img')].some((img) => img.complete && img.naturalWidth > 1);
          this.querySelector('.rdtn-instagram__fallback').hidden = ready;
        };
        this.observer = new MutationObserver(refresh);
        this.observer.observe(feed, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
        feed.addEventListener('load', refresh, true);
        refresh();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdtn-support-page"]) return;
  try {
    
  if (!customElements.get('rdtn-help-content')) {
    customElements.define('rdtn-help-content', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-faq') || this.dataset.ready) return;
        this.dataset.ready = 'true';
        const toc = this.closest('.rdtn-support').querySelector('[data-faq-topics]');
        const fragment = document.createDocumentFragment();
        let group = fragment;
        let answer = null;
        let topicCount = 0;
        [...this.childNodes].forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
            group = document.createElement('section');
            group.className = 'rdtn-faq-topic';
            group.id = `${this.closest('.shopify-section').id}-topic-${++topicCount}`;
            fragment.append(group);
            group.append(node);
            answer = null;
            const link = document.createElement('a');
            link.href = `#${group.id}`;
            link.textContent = node.textContent;
            toc?.append(link);
          } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'P' && node.firstElementChild?.tagName === 'STRONG' && /[?？؟]$/.test(node.firstElementChild.textContent.trim()) && !node.firstChild.textContent.trim().replace(node.firstElementChild.textContent.trim(), '')) {
            const question = node.firstElementChild;
            const details = document.createElement('details');
            details.className = 'rdtn-faq-answer';
            const summary = document.createElement('summary');
            summary.textContent = question.textContent;
            question.remove();
            while (node.firstChild && ((node.firstChild.nodeType === Node.TEXT_NODE && !node.firstChild.textContent.trim()) || node.firstChild.nodeName === 'BR')) node.firstChild.remove();
            answer = document.createElement('div');
            answer.className = 'rdtn-faq-answer__body';
            if (node.textContent.trim() || node.querySelector('img,video,iframe')) answer.append(node);
            details.append(summary, answer);
            group.append(details);
          } else {
            (answer || group).append(node);
          }
        });
        this.replaceChildren(fragment);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
